var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeisure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#439BD9",
    width: "800px",
    height: "800px",
    viewBox: "0 -1.26 122.88 122.88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 122.88 120.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.94,102.48h85.62c3.71-3.85,8.02-14.75,12.45-25.96c1.41-3.57,2.83-7.17,4.3-10.66 c-6.43,0.02-15.18-0.61-16.52-2.15c-1.04-1.19-0.66-2.93,0.91-5.12l18.93-18.48c1.77-1.6,3.31-2.21,4.62-1.81 c1.3,0.39,2.38,1.76,3.23,4.13c0.48,7.13,0.43,14.27-0.63,21.4c-0.58,0.34-1.18,0.63-1.79,0.89c-2.01,4.48-4.01,9.56-6,14.58 c-3.41,8.63-6.75,17.09-10.52,23.18h10.39c4.92,0,8.94,4.02,8.94,8.94v0c0,4.92-4.02,8.94-8.94,8.94h-105 c-4.92,0-8.94-4.02-8.94-8.94v0C0,106.51,4.02,102.48,8.94,102.48L8.94,102.48z M36.43,36.39l-0.27-0.45l-7.06,1.01L26.54,52.6 c-0.48,2.93-3.23,4.91-6.16,4.44c-2.93-0.48-4.91-3.23-4.44-6.16l3.2-19.55c0.39-2.38,2.28-4.13,4.54-4.45l0,0l13.67-1.96 l10.11-2.21c5.76,0.19,10.06,2.61,12,7.7c0.28,0.35,0.52,0.75,0.71,1.18l5.42,12.39l17.68,1.1c2.96,0.17,5.22,2.72,5.04,5.68 c-0.17,2.96-2.72,5.22-5.68,5.05l-20.97-1.3c-2.16-0.13-3.95-1.52-4.69-3.41l-1.1-2.51l-2.25,9.79l14.84,8.74 c1.29,0.75,2.14,1.96,2.48,3.3l0.02,0l5.39,21.11c0.73,2.88-1.01,5.81-3.89,6.54c-2.88,0.73-5.81-1.01-6.54-3.89L61.1,75.19 l-1.24-0.73l-15.42-5.87l-0.83,0.46l-4.71,12.49c-0.34,0.9-0.89,1.65-1.58,2.23l0,0L19.65,98.6c-2.28,1.9-5.66,1.6-7.57-0.67 c-1.9-2.28-1.6-5.66,0.67-7.57L29.03,76.7C30.22,62.9,32.82,49.5,36.43,36.39L36.43,36.39z M57.91,0c5.64,0,10.21,4.57,10.21,10.21 c0,5.64-4.57,10.21-10.21,10.21c-5.64,0-10.21-4.57-10.21-10.21C47.7,4.57,52.27,0,57.91,0L57.91,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure);
export default __webpack_public_path__ + "static/media/leisure.a3974858b0c7818ca78bee230903d3be.svg";
export { ForwardRef as ReactComponent };